<template>
  <div ref="public" id="app">
    <!-- 最顶部导航 -->
    <div id="fixedTop" ref="topBox" :class="className" @mouseenter="tabsColor = true; cursor = true"
      @mouseleave="scrollTop > 0 ? cursor = false : tabsColor = false; cursor = false"
      :style="`background-color: ${tabsColor ? '#fff' : 'transparent'};`">
      <!-- logo -->
      <div id="logo">
        <img v-if="tabsColor" @click="navi({ url: 'home' }, 0)" src="./assets/logo.png" alt="" />
        <img v-else @click="navi({ url: 'home' }, 0)" src="./assets/logo2.png" alt="" />
      </div>
      <div id="fixedTopRight" @mouseleave="leave">
        <div class="listBox" @click.stop="navi(item, item.index)" v-for="(item, index) in tabs" :key="index">
          <!-- 文字 -->
          <div class="fontBox" @mouseenter="mouseenter(item.index)"
            :style="`width:${item.index == 5 ? 'calc(var(--vw) * 100px)' : ''};color: ${tabsColor ? (tabsIndex == item.index ? '#002672' : '#333') : '#fff'}`">
            <img v-if="item.index == 5" :src="require(`@/assets/map${tabsColor ? 1 : ''}.png`)" alt="">
            {{ $t(`导航.${item.name}`) }}
          </div>
          <!-- 下面的线条  指示器 -->
          <div class="line" :style="`background: ${tabsColor ? '#002672' : '#fff'};`" v-if="tabsIndex == item.index">
          </div>
          <!-- 悬浮窗 -->
          <div class="xuanfu" style="width: calc(100% + var(--vw) * 100px);left: calc(var(--vw) * -50px);" v-if="item.index == 1 && show1" @mouseleave="mouseleave(1)">
            <div class="bar" @click.stop="navi({ url: 'about' }, 1)"></div>
            <div class="xuanfuBox">
              <div class="lines" @click="tiao('fushengIndex', 0, 1)"><router-link to="/about">{{
      $t('导航.关于富晟智能网联.公司概述') }}</router-link></div>
              <div class="lines" @click="tiao('fushengIndex', 1, 1)"><router-link to="/about">{{
      $t('导航.关于富晟智能网联.发展历程') }}</router-link></div>
              <div class="lines" @click="tiao('fushengIndex', 2, 1)"><router-link to="/about">{{
      $t('导航.关于富晟智能网联.资质荣誉') }}</router-link></div>
              <div class="lines" @click="tiao('fushengIndex', 3, 1)"><router-link to="/about">{{
      $t('导航.关于富晟智能网联.企业文化') }}</router-link></div>
              <!-- <div class="lines" @click.stop="guanwang">{{
      $t('导航.关于富晟智能网联.关于富晟') }}</div> -->
              <div class="lines" @click="tiao('fushengIndex', 4, 1)"><router-link to="/about">{{
      $t('导航.关于富晟智能网联.联系我们') }}</router-link></div>
            </div>
          </div>
          <div class="xuanfu" style="width: calc(100% + var(--vw) * 100px);left: calc(var(--vw) * -50px);"
            v-if="item.index == 2 && show2" @mouseleave="mouseleave(2)">
            <div class="bar" @click.stop="navi({ url: 'Product_Center' }, 2)"></div>
            <div class="xuanfuBox">
              <div class="lines" v-for="(item, index) in chanpin" :key="index" @click="tiao('chanpinIndex', index, 2)">
                <router-link to="/Product_Center">{{
      $t(`导航.产品中心.${item.name}`) }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 组件路由 -->
    <router-view @fuwuClick="tabsIndex = 3; newIndex = 3"
      @chanpinClick="(e) => { chanpinIndex = e; tabsIndex = 2; newIndex = 2 }"
      :titles="$t(`导航.产品中心.${chanpin[chanpinIndex].name}`)" :chanpinIndex="chanpinIndex" :type="fushengIndex"
      @tabsClick="(e) => fushengIndex = e" />
    <div class="footer">
      <!-- 上 -->
      <!-- <div class="iconList">
        <div class="iconListLeft">
          <img src="./assets/public/icon1.png" alt="">
          <img src="./assets/public/icon2.png" alt="">
          <img src="./assets/public/icon3.png" alt="">
          <img src="./assets/public/icon4.png" alt="">
        </div>
        <div class="iconListRight">富晟智能网联</div>
      </div> -->
      <!-- 中 -->
      <div class="zhong">
        <div class="zhongLeft">
          <div class="zhongList">
            <div class="title">{{ $t('导航.产品中心.产品中心') }}</div>
            <div class="desc" @click="tiao('chanpinIndex', 0, 2)"><router-link class="desc" to="/Product_Center">{{
      $t('导航.产品服务.车身电子') }}</router-link>
            </div>
            <div class="desc" @click="tiao('chanpinIndex', 1, 2)"><router-link class="desc" to="/Product_Center">{{
      $t('导航.产品服务.智能座舱') }}</router-link>
            </div>
            <div class="desc" @click="tiao('chanpinIndex', 2, 2)"><router-link class="desc" to="/Product_Center">{{
      $t('导航.产品服务.智能驾驶') }}</router-link>
            </div>
            <div class="desc" @click="tiao('chanpinIndex', 3, 2)"><router-link class="desc" to="/Product_Center">{{
      $t('导航.产品服务.车联网') }}</router-link>
            </div>
          </div>
          <div class="zhongList">
            <div class="title">{{
      $t('导航.关于富晟智能网联.关于富晟') }}</div>
            <div class="desc" @click.stop="guanwang">{{
      $t('导航.关于富晟智能网联.富晟集团') }}</div>
            <div class="desc" @click="tiao('fushengIndex', 0, 1)"><router-link class="desc" to="/about">{{
      $t('导航.关于富晟智能网联.智能网联事业部') }}</router-link></div>
            <!-- <div class="desc" @click="tiao('fushengIndex', 1, 1)"><router-link class="desc" to="/about">{{
      $t('导航.关于富晟智能网联.发展历程') }}</router-link></div>
            <div class="desc" @click="tiao('fushengIndex', 2, 1)"><router-link class="desc" to="/about">{{
      $t('导航.关于富晟智能网联.资质荣誉') }}</router-link></div> -->
          </div>
          <div class="zhongList" style="width: calc(var(--vw) * 750px);">
            <div class="title">{{$t('导航.联系我们.联系我们') }}</div>
            <!-- <div class="desc">{{$t('导航.联系我们.电话') }}</div> -->
            <div class="desc">{{$t('导航.联系我们.邮箱') }}</div>
            <div class="desc">{{$t('导航.联系我们.常州总部') }}</div>
            <div class="desc">{{$t('导航.联系我们.长春基地') }}</div>
          </div>
        </div>
        <div class="zhongRight">
          <img src="./assets/public/card.jpg" alt="">
          <!-- <div> {{ $t('导航.首页.电话') }} ：0510-66600888</div>
          <div>{{ $t('导航.首页.邮箱') }}：contact@fawsn-ae.com</div> -->
        </div>
      </div>
      <!-- 下 -->
      <div class="bottom">
        <div>Copyright © 2025.苏ICP备2025185866号 All rights reserved.</div>
        <div>Privacy | Terms and condition</div>
      </div>
    </div>
  </div>
</template>
<script>
// import homePage from '@/components/homePage.vue'
export default {
  // name: 'HomeView',
  // components: {
  //   homePage
  // },
  data() {
    return {
      chanpinIndex: 0,
      chanpin: [{
        name: '车身电子产品线'
      }, {
        name: '智能座舱产品线'
      }, {
        name: '智能驾驶产品线'
      }, {
        name: '车联网产品线'
      }],
      tabsIndex: sessionStorage.getItem("tabsIndex") || 0,
      newIndex: sessionStorage.getItem("tabsIndex") || 0,
      scrollTop: 0,//上下滑动距离顶部的距离
      tabsColor: false,//是否切换导航颜色
      cursor: false,//鼠标是否在顶部导航
      className: 'end',
      mediaQuery: null,
      show1: false,
      show2: false,
      fushengIndex: localStorage.getItem("fushengIndex")
        ? localStorage.getItem("fushengIndex")
        : 0, //关于富晟的类型索引
      chanpinIndex: localStorage.getItem("chanpinIndex")
        ? localStorage.getItem("chanpinIndex")
        : 0, //产品中心的类型索引
      tabs: [
        {
          name: '首页.首页',
          url: 'home',
          index: 0
        }, {
          name: '关于富晟智能网联.关于富晟',
          url: 'https://www.fawsn.com.cn/',
          index: 6
        }, {
          name: '关于富晟智能网联.关于富晟智能网联',
          url: 'about',
          index: 1
        }, {
          name: '产品中心.产品中心',
          url: 'Product_Center',
          index: 2
        }, {
          name: '生产开发服务',
          url: 'Service',
          index: 3
        }, {
          name: '招贤纳士.招贤纳士',
          url: 'AttractTalents',
          index: 4
        }, {
          name: 'lang',
          url: '',
          index: 5
        },
      ]
    };
  },
  created() {
    if (process.env.NODE_ENV === "production") {
      // 1.禁用右键菜单
      document.oncontextmenu = new Function("event.returnValue=false");
      // 2.禁止键盘F12键
      document.addEventListener("keydown", function (e) {
        if (e.key == "F12") {
          e.preventDefault();
        }
      });

      // 3.禁止进入调试模式
      setInterval(function () {
        check()
      }, 1000);
      var check = function () {
        function doCheck(a) {
          if (("" + a / a)["length"] !== 1 || a % 20 === 0) {
            (function () { }
            ["constructor"]("debugger")())
          } else {
            (function () { }
            ["constructor"]("debugger")())
          }
          doCheck(++a)
        }
        try {
          doCheck(0)
        } catch (err) { }
      };
    }
  },
  mounted() {
    const resetFontSize = () => {
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
      WeixinJSBridge.on('menu:setfont', () => resetFontSize());
    };
    document.addEventListener('WeixinJSBridgeReady', resetFontSize);
    setTimeout(() => {
      this.className = 'start'
    }, 100);
    // 监听屏幕尺寸变化
    this.mediaQuery = window.matchMedia("(max-width:1920px)")
    this.checkMatchMedia()
    this.mediaQuery.addListener(this.checkMatchMedia)
    window.addEventListener("resize", this.switchResize, false)
    // 监听页面滚动
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    // 移除监听屏幕尺寸变化
    if (this.mediaQuery) {
      this.mediaQuery.removeListener(this.checkMatchMedia)
    }
  },
  methods: {
    guanwang() {
      this.tabsColor = false
      window.open('https://www.fawsn.com.cn/', '_bank')
    },
    tiao(key, index, indexs) {
      this.tabsColor = false//顶部变透明
      if (indexs == 2) this.chanpinIndex = index
      //回到顶部
      window.scrollTo({
        top: 0
      })
      this.cursor = false
      this.scrollTop = 0
      this.$nextTick(() => {
        this[key] = index
        localStorage.setItem(key, index) // 存储到本地存储，防止页面刷新返回初始状态
      })
      this.show1 = false;
      this.show2 = false;
      this.newIndex = indexs;
      this.tabsIndex = indexs;
      sessionStorage.setItem("tabsIndex", indexs);
    },
    // 获取页面滚动距离
    handleScroll() {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (this.scrollTop > 0) {
        // 如果距离顶部大于0
        this.tabsColor = true
      } else if (this.scrollTop == 0 && !this.cursor) {
        // 如果距离顶部大于0并且鼠标不在顶部
        this.tabsColor = false
      }
    },
    navi(item, index) {
      let lang = localStorage.getItem('lang') == 'en' ? 'en' : ''
      if (item.index == 6) return window.open(`https://www.fawsn.com.cn/${lang}`, '_bank')
      if (this.newIndex != index && item.index != 5) {
        window.scrollTo({
          top: 0
        })
        sessionStorage.setItem("tabsIndex", index);
        // this.$store.state.tabsIndex = index
        this.tabsIndex = index
        this.newIndex = index
        this.show1 = false
        this.show2 = false
        this.$router.push({
          name: item.url
        })
      } else if (item.index == 5) {
        // 切换中英文
        this.$nextTick(() => {
          let lang = localStorage.getItem('lang') == 'en' ? 'zh' : 'en'
          this.$store.commit('setLangInfo', lang)
          localStorage.setItem('lang', lang) // 存储到本地存储，防止页面刷新返回初始状态
          this.$i18n.locale = lang
        })
      }
    },
    clicks() {
      this.$store.state.index = 1
    },
    mouseenter(index) {
      if (index == 1) this.show1 = true
      if (index == 2) this.show2 = true
      this.tabsIndex = index
    },
    leave() {
      this.tabsIndex = sessionStorage.getItem("tabsIndex") || 0
    },
    mouseleave(index) {
      if (index == 1) this.show1 = false
      if (index == 2) this.show2 = false
    },
    switchResize() {
      this.size()
    },
    checkMatchMedia() {
      this.size()
    },
    size() {
      // const deviceWidth = document.documentElement.clientWidth || document.body.clientWidth;
      const vw = this.$refs.public.getBoundingClientRect().width / 1920;
      document.documentElement.style.setProperty("--vw", vw)
      // const vh = window.innerHeight / 1080;
      // const screenwidth = window.innerWidth;
      // const rpx = screenwidth / (750 * 1);
      // const screenWidth = window.innerWidth;
      // let rpx = (750 / screenWidth) * 1 * (screenWidth / 375) * (screenWidth / 375);
      // document.documentElement.style.setProperty("--vh", vh)
      // document.documentElement.style.setProperty("--rpx", rpx)
    },
  }
};
</script>
<style lang="less">
div {
  font-family: CALIBRI;
}

@font-face {
  font-family: 'CALIBRI'; // 引入字体包，自己起的名字
  src: url('@/assets/CALIBRI.ttf'); // 字体包本地路径
  font-weight: normal;
  font-style: normal;
}

::-webkit-scrollbar {
  width: 0 !important;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}

.Datitle {
  font-weight: 400;
  font-size: calc(var(--vw) * 70px);
  color: #FFFFFF;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

//开始动态效果
.start {
  opacity: 1;
  transform: translateY(0);
  transition: all 1s;
}

.end {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1s;
}

.image1 {
  width: calc(var(--vw) * 1920px);
  height: calc(var(--vw) * 972px);
  display: block;
}

.image2 {
  width: calc(var(--vw) * 1920px);
  height: calc(var(--vw) * 1013px);
  display: block;
}

.image3 {
  width: calc(var(--vw) * 1920px);
  height: calc(var(--vw) * 809px);
  display: block;
}

#app {
  font-family: CALIBRI;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#fixedTop {
  width: calc(var(--vw) * 1920px);
  height: calc(var(--vw) * 128px);
  min-height: calc(var(--vw) * 20px);
  display: flex;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 11;
  transition: all 0.5s;

  @media (max-width: 1060px) {
    #logo {
      width: calc(var(--vw) * 280px);
      // width: 280px;
      background-color: transparent;
      height: calc(var(--vw) * 128px);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: calc(var(--vw) * 61px);

      img {
        width: calc(var(--vw) * 220px);
        // width: 180px;
        height: calc(var(--vw) * 51px);
      }
    }
  }

  @media (min-width: 1060px) {
    #logo {
      width: calc(var(--vw) * 280px);
      // width: 280px;
      background-color: transparent;
      height: calc(var(--vw) * 128px);
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: calc(var(--vw) * 50px);

      img {
        width: calc(var(--vw) * 220px);
        // width: 180px;
        height: calc(var(--vw) * 51px);
      }
    }
  }

  @media (max-width: 1060px) {
    #fixedTopRight {
      margin-left: 10%;
      flex: 1;
      display: flex;
      align-items: center;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      padding-right: calc(var(--vw) * 107px);
    }
  }

  @media (min-width: 1060px) {
    #fixedTopRight {
      margin-left: 20%;
      flex: 1;
      display: flex;
      align-items: center;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      padding-right: calc(var(--vw) * 107px);
    }
  }

  .listBox {
    position: relative;
    cursor: pointer;
    height: calc(var(--vw) * 128px);
    display: flex;
    align-items: center;

    .fontBox {
      font-size: calc(var(--vw) * 20px);
      display: flex;
      align-items: center;

      img {
        width: calc(var(--vw) * 30px);
        height: calc(var(--vw) * 30px);
        margin-right: calc(var(--vw) * 10px);
      }
    }

    .xuanfu {
      position: absolute;
      width: 100%;
      top: 0;
      z-index: 11;

      .bar {
        height: calc(var(--vw) * 128px);
      }

      .xuanfuBox {
        width: 100%;
        // height: calc(var(--vw) * 303px);
        background: #000000;
        opacity: 0.8;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        align-content: space-evenly;

        .lines {
          font-weight: 500;
          font-size: calc(var(--vw) * 20px);
          color: #FFFFFF;
          width: 100%;
          text-align: center;
          height: calc(var(--vw) * 54px);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .lines:hover {
          color: #fff;
          background-color: #002672;
          opacity: 0.8;
        }
      }
    }

    .line {
      position: absolute;
      bottom: calc(var(--vw) * 35px);
      width: calc(var(--vw) * 40px);
      height: calc(var(--vw) * 4px);
      left: 50%;
      transform: translate(-50%);
    }
  }
}

a {
  font-weight: bold;
  color: #fff;
  text-decoration: none;
}

a.router-link-exact-active {
  color: #fff;
  text-decoration: none;
}

.footer {
  height: calc(var(--vw) * 458.67);
  width: calc(var(--vw) * 1920px);
  background-color: #142131;

  .zhong {
    height: calc(var(--vw) * 416px);
    border: calc(var(--vw) * 1px) solid #eee;
    padding: calc(var(--vw) * 65px) calc(var(--vw) * 130.67px) 0 calc(var(--vw) * 130.67px);
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: space-between;

    .zhongLeft {
      width: calc(var(--vw) * 1383px);
      display: flex;
      justify-content: space-between;

      .zhongList {
        text-align: left;
        cursor: pointer;

        .title {
          font-weight: 500;
          font-size: calc(var(--vw) * 28px);
          color: #FFFFFF;
        }

        .desc {
          font-weight: 400;
          font-size: calc(var(--vw) * 21px);
          color: #F3E5E6;
          margin-top: calc(var(--vw) * 10px);
        }
      }
    }

    .zhongRight {
      text-align: left;

      img {
        width: calc(var(--vw) * 200px);
        height: calc(var(--vw) * 200px);
      }

      div {
        font-weight: 600;
        font-size: calc(var(--vw) * 21px);
        color: #FFFFFF;
        margin-top: calc(var(--vw) * 10px);
      }
    }
  }

  .bottom {
    height: calc(var(--vw) * 42.67px);
    padding: 0 calc(var(--vw) * 130.67px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    div {
      font-weight: 600;
      font-size: calc(var(--vw) * 16px);
      color: #FFFFFF;
    }
  }

  .iconList {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    height: calc(var(--vw) * 85.33px);
    padding: 0 calc(var(--vw) * 130.67px);

    .iconListLeft {

      width: calc(var(--vw) * 32px * 4 + var(--vw) * 2px * 4);
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;

      img {
        width: calc(var(--vw) * 32px);
        height: calc(var(--vw) * 32px);
      }
    }

    .iconListRight {
      font-weight: 600;
      font-size: calc(var(--vw) * 21px);
      color: #FFFFFF;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>
